import React, { useEffect, useState, useCallback, useRef } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu"; 
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon"; 
import { Link } from "react-router-dom";

const GNBPURE04001S = () => {
  const { doAction } = useApplicationCommon(); // ✅ `doAction`만 사용
  const [isDepthOpen, setIsDepthOpen] = useState(false); // depth2 메뉴 열림 상태
  const [companyInfo, setCompanyInfo] = useState("");
  const [formData, setFormData] = useState({
    agree: "2",
    qna_dv_cd: "TN",
    inq_co_nm: "",
    cust_nm: "",
    telno: "",
    email_id: "",
    qna_cntn: "",
  });

  useEffect(() => {
    // 메인테스트      
    const hostname = window.location.hostname;
    if (hostname.includes("gnbsoftec.co.kr")) {
      setCompanyInfo("지앤비소프텍");
    } else if (hostname.includes("puresolution.co.kr")) {
      setCompanyInfo("퓨어솔루션");
    } else {
      setCompanyInfo("퓨어솔루션");
    }
    
  }, []);

  const formRef = useRef(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  
  const goRegist = async () => {
   
    if (formData.agree !== "1") return;

    if (!formData.inq_co_nm) {
      alert("회사명을 입력해주세요.");
      return;
    }

    if (!formData.cust_nm) {
      alert("성명을 입력해주세요.");
      return;
    }

    if (!formData.telno) {
      alert("연락처를 입력해주세요.");
      return;
    }

    if (!formData.email_id) {
      alert("이메일을 입력해주세요.");
      return;
    }

    if (!formData.qna_cntn) {
      alert("문의내용을 입력해주세요.");
      return;
    }
    
    formData.txGbnCd = "regist";
    formData.co_no = "1";

    doAction("COM0002SC", formData, (resData) => {
      if (resData.APP_HEADER.respCd === "N00001") {
        alert("제휴문의가 등록되었습니다.");
        window.location.href = "/GNBPURE04001S";
      }else {
        alert(resData.APP_HEADER.respMsg);
      }
    });

    
  };

  const goCancel = async () => {
   
    window.location.href = "/GNBPURE04001S";

  };
  
  return (
    <CommonLayout>
      <CommonMenu/>
      
      <div id="contents" className="container">
        <div className="sub-title bg-type05">
          <h2>고객지원</h2>	
        </div>
        <div className="location_wrap">
          <ul className="depth1"  onClick={() => setIsDepthOpen(!isDepthOpen)}>
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>제휴문의<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE04001S">제휴문의</Link></li>
                <li><Link to="/GNBPURE04002S">NOTICE</Link></li>
                <li><Link to="/GNBPURE04003S">Contact Us</Link></li>
              </ul>
            </li>
          </ul>
        </div>
        <form id="actionForm">
        <div id="cont" className="cont">
          <div className="inner">
            <h3>제휴문의</h3>
            <article>
              <p className="subtitle bor-b">필수 고객정보 이용동의</p>
              <dl className="list-box bul-dot">
                <dt className="txt-tit01">&#42; 개인정보 수집 &#183; 이용 관련 동의서</dt>
                <dd>저희 &#10088;주&#10089;{companyInfo}은 고객의 개인정보를 중요시 하며, 이에 고객문의와 관련하여 개인정보 수집 &#183; 이용 관련 동의를 다음과 같이 받고자 합니다.</dd>
                <dd>개인(신용)정보 수집 &#183; 이용 관련 동의
                  <ul className="bul-hypn">
                    <li>수집&#47;이용 항목 &#58; 고객명, 휴대폰 번호, 이메일 주소</li>
                    <li>수집&#47;이용 목적 &#58; 고객문의처리</li>
                    <li>개인정보의 수집 &#183; 이용 관련 동의일로부터 1년까지 활용 후, 파기됩니다.</li>
                  </ul>
                </dd>
                <dd>본인은 위와 같이 개인정보를 수집 &#183; 이용하는데 대한 동의를 거부할 수 있습니다. 이에 대한 동의가 없을 경우 고객문의 접수가 불가함을 알려드립니다.</dd>
              </dl>
              <ul className="rdi-wrap mt10">
                <li>
                  <input type="radio" id="agree01_01" onChange={handleChange} name="agree" value="1"/>
                  <label htmlFor="agree01_01" tabIndex="0">동의</label>
                </li>
                <li>
                  <input type="radio" id="agree01_02" onChange={handleChange} name="agree" value="2" defaultChecked={formData.agree === "2"} />
                  <label htmlFor="agree01_02" tabIndex="0">미동의</label>
                </li>
              </ul>
            </article>

            <article>
              <p className="subtitle bor-b">정보입력</p>
              <div className="form-wrap">
                <p className="txt-tit01">문의구분</p>
                <ul className="rdi-wrap">
                  <li>
                    <input type="radio" id="radio01_01" onChange={handleChange} className="" name="qna_dv_cd" value="SI"/>
                    <label htmlFor="radio01_01" tabIndex="0">영업구분</label>
                  </li>
                  <li>
                    <input type="radio" id="radio01_02" onChange={handleChange} className="" name="qna_dv_cd" value="TN" defaultChecked={formData.qna_dv_cd === "TN"}/>
                    <label htmlFor="radio01_02" tabIndex="0">기술문의</label>
                  </li>
                </ul>
              </div>
              <div className="form-wrap">
                <ul className="form-col02">
                  <li>
                    <label htmlFor="company01">회사명</label>
                    <input type="text" id="company01" onChange={handleChange} name="inq_co_nm" placeholder="회사명을 입력해주세요."/>
                  </li>
                  <li>
                    <label htmlFor="name01">성명</label>
                    <input type="text" id="name01" onChange={handleChange} name="cust_nm" placeholder="성명과 직책을 입력해주세요."/>
                  </li>
                </ul>
              </div>
              <div className="form-wrap">
                <ul className="form-col02">
                  <li>
                    <label htmlFor="tel01">연락처</label>
                    <input type="tel" id="tel01" onChange={handleChange} name="telno" placeholder="숫자만 입력해주세요."/>
                  </li>
                  <li>
                    <label htmlFor="email01">이메일</label>
                    <input type="text" id="email01" onChange={handleChange} name="email_id" placeholder="이메일을 입력해주세요."/>
                  </li>
                </ul>
              </div>
              <div className="form-wrap">
                <label htmlFor="cntn01">문의내용</label>
                <textarea id="cntn01" onChange={handleChange} name="qna_cntn" placeholder="문의내용을 입력해주세요."></textarea>
              </div>
            </article>

            <ul className="pc btn-wrap">
              <li><button type="button" onClick={goCancel}  className="btn bor btn-default">취소</button></li>
              <li><button type="button" onClick={goRegist} className="btn btn-primary btn-ques" >문의하기</button></li>
            </ul>

            <ul className="mo btn-wrap col02">
              <li><button type="button" onClick={goCancel}  className="btn bor btn-default">취소</button></li>
              <li><button type="button" onClick={goRegist} className="btn btn-primary btn-ques">문의하기</button></li>
            </ul>

          </div>
        </div>
        </form>
      </div>
      <CommonFooter/>
    </CommonLayout>
  );
};

export default GNBPURE04001S;